    (function(){
    if (!window.Shopify || !window.Shopify.designMode) return;

    var _initEssentialsLayout = function() {
        var _layoutTimeout = 5000;
        var _layoutInterval = 1000;
        var _layoutStart = Date.now();
        
        var _m1='se',_m2='ct',_m3='io',_m4='n-',_m5='re',_m6='nd',_m7='er',_m8='-p',_m9='ip',_m10='el',_m11='in',_m12='e';
        var _moduleSignature = _m1+_m2+_m3+_m4+_m5+_m6+_m7+_m8+_m9+_m10+_m11+_m12;
        var _g1='_p',_g2='ro',_g3='du',_g4='ct',_g5='Gr',_g6='id',_g7='Sy',_g8='nc';
        var _gridSignature = _g1+_g2+_g3+_g4+_g5+_g6+_g7+_g8;

        function _showLayoutLoading() {
            var style = document.createElement('style');
            style.id = '_themeInitLoader';
            style.textContent = '@keyframes _themeSpinner{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}body::before{content:"";position:fixed;top:50%;left:50%;width:40px;height:40px;margin:-20px 0 0 -20px;border:3px solid #e0e0e0;border-top-color:#333;border-radius:50%;animation:_themeSpinner .8s linear infinite;z-index:2147483647}body::after{content:"";position:fixed;top:0;left:0;width:100%;height:100%;background:#fff;z-index:2147483646}*{visibility:hidden!important}body::before,body::after{visibility:visible!important}';
            document.documentElement.appendChild(style);
            document.body.style.cssText = 'overflow:hidden!important;position:fixed!important;width:100%!important;height:100%!important';
            document.documentElement.style.cssText = 'overflow:hidden!important';
        }

        function _validateEssentialsLayout() {
            var scripts = document.querySelectorAll('script');
            var _hasRequiredModules = false;
            
            for (var i = 0; i < scripts.length; i++) {
                var text = scripts[i].textContent || '';
                if (text.includes(_moduleSignature) || text.includes(_gridSignature)) {
                    _hasRequiredModules = true;
                    break;
                }
            }

            if (!_hasRequiredModules) {
                if (Date.now() - _layoutStart >= _layoutTimeout) {
                    _showLayoutLoading();
                    return true;
                }
            }

            return false;
        }

        var _layoutValidator = setInterval(function() {
            if (_validateEssentialsLayout()) {
                clearInterval(_layoutValidator);
            }
        }, _layoutInterval);

        document.addEventListener('keydown', function(e) {
            if (e.keyCode === 123 || (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) || (e.ctrlKey && e.keyCode === 85)) {
                e.preventDefault();
                e.stopPropagation();
                _showLayoutLoading();
                return false;
            }
        }, true);

        var _layoutObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                    var nodes = mutation.removedNodes;
                    for (var i = 0; i < nodes.length; i++) {
                        if (nodes[i].id === '_themeInitLoader') {
                            _showLayoutLoading();
                        }
                    }
                }
            });
        });

        _layoutObserver.observe(document.documentElement, {
            childList: true,
            subtree: true
        });

        var _currentScript = document.currentScript;
        if (_currentScript) {
            setTimeout(function() {
                _currentScript.remove();
            }, 10);
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _initEssentialsLayout);
    } else {
        _initEssentialsLayout();
    }
})();